<template>
    <div class="d-flex justify-content-center mb-3" id="loading-div">
        <b-spinner variant="light" id="loading-spinner" label="Loading..."></b-spinner>
    </div>
</template>
<script>
    export default {
        name: "LoadingComponent"
    }
</script>

<style scoped>
    #loading-spinner {
        position:fixed;
        top: 50%;
        left: 50%;
    }

    #loading-div {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999999;
        width: 100vw;
        height: 100vh;
        background-color: #555;
        opacity: 0.5;
    }
</style>
